export const PlatformController = {
    index(): void {},
    oaSdl(): void {},
    analyticalFacility(): void {},
    show(): void {},
};
